"use client"

import React from "react"

interface IObfuscatedLinkProps {
    encodedUrl: string
    label: string
    className?: string
    children: React.ReactNode
}

// SEO: no <a href>, URL kept in base64 so crawlers can't follow it and no PageRank leaks out.
export default function ObfuscatedLink({ encodedUrl, label, className = "", children }: IObfuscatedLinkProps) {
    const open = () => {
        const url = decodeURIComponent(window.atob(encodedUrl))
        window.open(url, "_blank", "noopener,noreferrer")?.focus()
    }

    return (
        <span
            role="link"
            tabIndex={0}
            aria-label={label}
            className={`cursor-pointer ${className}`}
            onClick={open}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault()
                    open()
                }
            }}
        >
            {children}
        </span>
    )
}
